import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Languages from '../page/OrgSettings/Languages/Languages';
import LanguageContext  from '../../context/LanguageContext';

class LanguagesPortal extends Component {
  render() {

    // Container ref
    const targetContainer = document.getElementById('react-languages-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
      <LanguageContext>
        <Languages />
      </LanguageContext>, targetContainer
    );
  }
}

export default LanguagesPortal;